import React from 'react';
import './nav-drop-down.css';
import DropDownItem from './drop-down-item';
import { motion } from 'framer-motion'
const NavDropDown = ({ array }) => {
  return (
    <motion.div initial={{ y: "-100vw" }} animate={{ y: 0 }} className="container">
      {array.map((product, index) => (
        <DropDownItem
          key={index}
          icon={product.icon}
          itemName={product.itemName}
          detail={product.detail}
        />
      ))}
    </motion.div>
  );
};

export default NavDropDown;
